import { render } from "./Left.vue?vue&type=template&id=f445a24e&scoped=true&ts=true"
import script from "./Left.vue?vue&type=script&lang=ts"
export * from "./Left.vue?vue&type=script&lang=ts"

import "./Left.vue?vue&type=style&index=0&id=f445a24e&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f445a24e"]])

export default __exports__